/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgPurchaseLimit = {
  header: 'Todos os limites de compra ({{count}})',

  name: 'Nome',
  code: 'Código',
  active: 'Estado',
  limit: 'Limite',
  orderApprovalPermissionCara: 'Cara',
  threshold: 'Limiar',
  periodRange: 'Período',
  currency: 'Uniforme',
  orgUnit: 'Unidadee dos pais',
  unit: 'Unidadee dos pais',
  actions: '',
  hint: 'Os limites de compra ajudam a controlar os gastos, definindo quanto os compradores podem gastar por pedido ou por semana, mês, trimestre ou ano. Os limites de compra são atribuídos a usuários ou grupos de usuários. Os limites de compra também são atribuídos aos aprovadores, definindo o quanto eles podem aprovar. Você pode atribuir limites de compra a vários usuários de uma só vez com grupos de usuários.',

  details: {
    title: 'Detalhes em Limite de compra',
    subtitle: 'Limite de compra: {{ item.code }}',
  },
  edit: {
    title: 'Editar Limite de Compra',
    subtitle: 'Limites de compra : {{ item.code }}',
  },
  create: {
    title: 'Criar limite de compra',
    subtitle: '',
  },

  sortBy: 'Classificar por',
  sort: {
    byName: 'Nome',
    byUnitName: 'Unidade',
  },

  messages: {
    deactivateTitle: 'Disable Este limite de compra?',
    deactivate:
      'Os limites de compra desativados não podem mais ser atribuídos a um usuário ou grupo de usuários. As atribuições atuais não terão efeito.',
    confirmEnabled: 'Limite de compra {{ item.code }} habilitado com sucesso',
    confirmDisabled: 'Comprar Limite {{ item.code }} desativado com sucesso',
    update: 'Limite de compra {{ item.code }} atualizado com sucesso',
    create: 'Comprar Limit {{ item.code }} criado com sucesso',
  },
  info: {
    disabledEdit: 'Ative o limite de compra para permitir a edição.',
    disabledEnable:
      'A unidade deve ser habilitada antes que esse limite de compra possa ser habilitado.',
  },

  per: {
    DAY: 'por dia',
    WEEK: 'por semana',
    MONTH: 'por mês',
    QUARTER: 'por trimestre',
    YEAR: 'por ano',
  },

  breadcrumbs: {
    list: 'Todos os limites de compra',
    details: '{{code}}',
  },
};
